import { useCallback, useRef } from "react";

export interface UseMonthScrollSyncResult {
  bottomMonthScrollbarRef: React.RefObject<HTMLDivElement>;
  syncMonthScroll: (sourceKey: string, scrollLeft: number) => void;
  registerMonthScroller: (key: string) => (node: HTMLDivElement | null) => void;
}

export const useMonthScrollSync = (): UseMonthScrollSyncResult => {
  const monthScrollerRefs = useRef<Record<string, HTMLDivElement | null>>({});
  const bottomMonthScrollbarRef = useRef<HTMLDivElement | null>(null);
  const isSyncingMonthScrollRef = useRef(false);

  const syncMonthScroll = useCallback(
    (sourceKey: string, scrollLeft: number) => {
      if (isSyncingMonthScrollRef.current) {
        return;
      }

      isSyncingMonthScrollRef.current = true;
      Object.entries(monthScrollerRefs.current).forEach(([key, node]) => {
        const targetScroller = node;
        if (!targetScroller || key === sourceKey) {
          return;
        }
        if (Math.abs(targetScroller.scrollLeft - scrollLeft) > 1) {
          targetScroller.scrollLeft = scrollLeft;
        }
      });

      if (
        sourceKey !== "__bottom__" &&
        bottomMonthScrollbarRef.current &&
        Math.abs(bottomMonthScrollbarRef.current.scrollLeft - scrollLeft) > 1
      ) {
        bottomMonthScrollbarRef.current.scrollLeft = scrollLeft;
      }

      isSyncingMonthScrollRef.current = false;
    },
    [],
  );

  const registerMonthScroller = useCallback(
    (key: string) => (node: HTMLDivElement | null) => {
      monthScrollerRefs.current[key] = node;
    },
    [],
  );

  return {
    bottomMonthScrollbarRef,
    syncMonthScroll,
    registerMonthScroller,
  };
};
